import type { Column } from "./types";

export const getColumnWidth = (col: Column<any>) => {
  if (typeof col.width === "number") return col.width;
  if (typeof col.minWidth === "number") return col.minWidth;
  return 0;
};

export const getLeftOffset = (columns: Column<any>[], colIndex: number) => {
  let left = 0;

  for (let i = 0; i < colIndex; i++) {
    if (columns[i].fixed === "left") {
      left += getColumnWidth(columns[i]);
    }
  }

  return left;
};

export const getGridTemplateColumns = (
  columns: Column<any>[],
  widthScrollBar: number,
  widthResizing: Record<string, number>,
) =>
  columns
    .map((col) => {
      if (col.key === "scroll") {
        return `${widthScrollBar}px`;
      }
      const min =
        typeof col.minWidth === "number" ? `${col.minWidth}px` : undefined;
      const max =
        typeof col.maxWidth === "number" ? `${col.maxWidth}px` : undefined;
      const width =
        typeof col.width === "number"
          ? `${col.width}px`
          : col.width ?? undefined;
      if (widthResizing[col.key]) {
        return `${widthResizing[col.key]}px`;
      }
      if (min && max) return `minmax(${min}, ${max})`;
      if (min && width) return `minmax(${min}, ${width})`;
      if (min) return `minmax(${min}, 1fr)`;
      if (width) return width;
      return "1fr";
    })
    .join(" ");
